import { ReactNode } from 'react';

// Shared cell classes for the card-table pattern below.
export const tableHeaderCellClass = 'text-left px-4 py-2.5 text-foreground/60 font-medium';
export const tableCellClass = 'px-4 py-2.5 text-foreground/80';

// Header row for a TableCard; an empty-string label renders an empty <th>
// (e.g. above an actions column).
export const TableHeaderRow = ({ labels }: { labels: string[] }) => (
    <thead>
        <tr className={'border-b border-foreground/10'}>
            {labels.map((label, index) => (
                <th key={`${index}-${label}`} className={tableHeaderCellClass}>
                    {label}
                </th>
            ))}
        </tr>
    </thead>
);

// Card-wrapped table per the design-system table pattern (reference:
// pages/assets/components/RecentBookingsSection.tsx). Children are the
// <thead>/<tbody> of the table.
const TableCard = ({ children }: { children: ReactNode }) => (
    <div className={'bg-text-contrast rounded-[5px] shadow-sm overflow-x-auto'}>
        <table className={'w-full text-sm'}>{children}</table>
    </div>
);

export default TableCard;
